﻿import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { WizardButtons } from '../../Wizard/WizardButtons';
import { RequestCashValueLetter } from '../../../../../api/cashvalrequest';
import { TitledCircularProgress } from '../../feedback/TitledCircularProgress/TitledCircularProgress';
import { Alert } from '@mui/material';

const ConfirmCVLRequest = (props) => {
  const sendRequest = useMutation({
    mutationFn: async () =>
      await RequestCashValueLetter({ PolicyID: props.referenceID, Source: 4 })(),
    gcTime: 1,
  });

  useEffect(() => {
    if (sendRequest.isSuccess && sendRequest.data) {
      if (sendRequest.data.canRequest) {
        props.nextHandler();
      } else {
        props.errorHandler();
      }
    }
  }, [sendRequest.isSuccess, sendRequest.data]);

  const executeNext = () => {
    if (props.referenceID) {
      sendRequest.mutate();
    }
  };

  const renderAlertMessage = () => {
    if (sendRequest && sendRequest.data && sendRequest.data.errorCode) {
      if (sendRequest.data.errorCode === 'NotActive') {
        return 'The entered policy is either terminated or could not be located. Please call customer service for more information at 800-628-5433';
      } else {
        return 'A system error has occurred. Please try again later.';
      }
    } else {
      return 'Please contact Policy Holder Services to complete your request.';
    }
  };

  return (
    <>
      <div>
        Are you sure you would like to submit a Cash Value letter request for policy{' '}
        {`${props.referenceID}?`} Press Next to submit the request.
      </div>
      <Alert severity="error">{renderAlertMessage()}</Alert>
      {!sendRequest.isPending && (
        <>
          <TitledCircularProgress title="" />
          <WizardButtons {...props} nextHandler={executeNext} />
        </>
      )}
    </>
  );
};

export { ConfirmCVLRequest };
